import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const SearchIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill={theme.colors.primary.variant7}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.6068 13.7267L12.5134 10.6667C13.3591 9.39955 13.7571 7.88618 13.6442 6.36696C13.5313 4.84775 12.914 3.40982 11.8904 2.28161C10.8667 1.15339 9.49537 0.399601 7.99426 0.139972C6.49314 -0.119656 4.94831 0.12977 3.60518 0.848629C2.26205 1.56749 1.19765 2.71455 0.581065 4.1076C-0.0355206 5.50064 -0.168927 7.05978 0.202038 8.53733C0.573003 10.0149 1.42706 11.3261 2.62855 12.2627C3.83003 13.1993 5.31003 13.7075 6.83343 13.7067C8.18542 13.708 9.50677 13.304 10.6268 12.5467L13.7268 15.6467C13.9766 15.895 14.3145 16.0344 14.6668 16.0344C15.019 16.0344 15.3569 15.895 15.6068 15.6467C15.7358 15.5223 15.8384 15.3732 15.9086 15.2082C15.9787 15.0433 16.0148 14.8659 16.0148 14.6867C16.0148 14.5074 15.9787 14.3301 15.9086 14.1651C15.8384 14.0002 15.7358 13.851 15.6068 13.7267ZM6.83343 2C7.78909 2 8.7233 2.28331 9.51799 2.8141C10.3127 3.3449 10.9322 4.09937 11.2982 4.98216C11.6642 5.86495 11.7603 6.83643 11.5744 7.77382C11.3884 8.71122 10.9287 9.57244 10.2535 10.2487C9.57818 10.9249 8.71758 11.3857 7.78045 11.573C6.84331 11.7602 5.8717 11.6655 4.98841 11.3007C4.10512 10.9359 3.34979 10.3174 2.8179 9.52344C2.28601 8.72948 2.00142 7.79566 2.0001 6.84C2.0001 5.55751 2.50911 4.32745 3.41534 3.41996C4.32158 2.51248 5.55094 2.00177 6.83343 2Z" />
      </svg>
    </Icon>
  );
};

export default SearchIcon;
